import { useEffect, useRef } from "react";

type UseGroupWidthProps = {
  setGroupWidth: (width: number) => void;
};

export function useGroupWidth(props: UseGroupWidthProps) {
  const { setGroupWidth } = props;

  const groupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (groupRef.current) {
      const observer = new ResizeObserver(([entry]) => {
        if (entry) {
          setGroupWidth(entry.contentRect.width);
        }
      });

      observer.observe(groupRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  return { groupRef };
}
